import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyPageMeta, getPageMeta } from "../utils/pageMeta";

const usePageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPageMeta(getPageMeta(pathname));
  }, [pathname]);
};

export default usePageMeta;
